<ng-container *transloco="let t">
  <div class="owner-statement-euthanasia">
    <div [formGroup]="form">
      <h3 class="mb-2">{{ t('ZAHTEV ZA EUTANAZIJU ŽIVOTINJE') }}</h3>

      <mat-form-field appearance="outline" class="w-full mb-3">
        <mat-label>{{ t('Justified reason for euthanasia') }}</mat-label>
        <textarea matInput rows="5" formControlName="justification"></textarea>
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-full mb-3">
        <mat-label>{{ t('veterinarianName') }}</mat-label>
        <input matInput formControlName="veterinarianName" />
        <mat-error>{{ t('This field is required') }}</mat-error>
      </mat-form-field>
    </div>
  </div>
</ng-container>
